/*
 * lodash used to be exposed here as window._. Nothing referenced it — no `_.`
 * call exists in resources/js, in any Blade view, or in the hand-written files
 * under public/assets/js (cookieconsent.js bundles its own copy). It was still
 * pulling 531 KB of source into vendor.js, which every page downloads, so the
 * import is gone. Reach for a scoped `import debounce from 'lodash/debounce'`
 * if a specific helper is ever needed again.
 */

try {
    require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
